(function () {
  var API_URL = 'https://api.reviews.io/stats/all';
  var CACHE_MINUTES = 60;
  var TIMEOUT_MS = 8000;

  function readCache(storeKey) {
    try {
      var cached = JSON.parse(sessionStorage.getItem('ck-rating-bar:' + storeKey));
      if (cached && Date.now() - cached.time < CACHE_MINUTES * 60 * 1000) return cached.data;
    } catch (e) {}
    return null;
  }

  function writeCache(storeKey, data) {
    try {
      sessionStorage.setItem('ck-rating-bar:' + storeKey, JSON.stringify({ time: Date.now(), data: data }));
    } catch (e) {}
  }

  function combine(stats) {
    var total = 0;
    var weighted = 0;

    ['product_review_stats', 'company_review_stats', 'third_party_review_stats'].forEach(function (key) {
      var group = stats && stats[key];
      if (!group) return;

      var count = parseInt(group.total_reviews, 10);
      var average = parseFloat(group.average_rating);
      if (!count || isNaN(average)) return;

      total += count;
      weighted += count * average;
    });

    return total ? { rating: weighted / total, count: total } : null;
  }

  function render(bar, data) {
    var max = parseFloat(bar.getAttribute('data-max-rating')) || 5;
    var label = bar.getAttribute('data-reviews-label');
    var decimalSeparator = bar.getAttribute('data-decimal-separator') || '.';
    var thousandsSeparator = bar.getAttribute('data-thousands-separator') || '';
    var score = bar.querySelector('[data-ck-rating-score]');
    var count = bar.querySelector('[data-ck-rating-count]');

    var ratingText = data.rating.toFixed(1).replace('.', decimalSeparator);
    var countText = String(data.count).replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

    if (score) score.textContent = ratingText + ' / ' + max;
    if (count) count.textContent = countText + (label ? ' ' + label : '');

    var stars = Math.round(data.rating * 2) / 2;
    var fill = Math.min(Math.max((stars / max) * 100, 0), 100);
    bar.style.setProperty('--ck-rating-bar-star-inset', 100 - fill + '%');
  }

  function load(bar) {
    var storeKey = bar.getAttribute('data-store-key');
    if (!storeKey) return;

    var cached = readCache(storeKey);
    if (cached) {
      render(bar, cached);
      return;
    }

    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller && setTimeout(function () { controller.abort(); }, TIMEOUT_MS);

    fetch(API_URL + '?store=' + encodeURIComponent(storeKey), controller ? { signal: controller.signal } : undefined)
      .then(function (response) {
        if (!response.ok) throw new Error('REVIEWS.io request failed');
        return response.json();
      })
      .then(function (stats) {
        var data = combine(stats);
        if (!data) return;
        writeCache(storeKey, data);
        render(bar, data);
      })
      .catch(function () {})
      .then(function () {
        if (timer) clearTimeout(timer);
      });
  }

  function init(container) {
    (container || document).querySelectorAll('[data-ck-rating-bar]').forEach(load);
  }

  init();
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
